import React from 'react';
import UserAvatar from 'components/pure/utils/UserAvatar';
import round from 'utils/round';
import './DonutTooltipContent.styl';

// TODO: a must be replaced with button and eslint ignore must be removed
/* eslint jsx-a11y/anchor-is-valid: "off", no-script-url: "off" */
export default class DonutTooltipContent extends React.PureComponent {
  render() {
    const {user, value, total, label} = this.props;
    return (
      <a href="javascript:;" onClick={this.props.onClick} className="donut-tooltip-content">
        {user && <UserAvatar user={user} />}
        <div>
          <div>
            <strong>{user && user.getFullName()} </strong>
          </div>
          <div>
            {round((value / total) * 100)}% of {label}
          </div>
        </div>
      </a>
    );
  }
}
